import { OrganizationBackupItem } from 'src/stores/organizations-store';

export const OrganizationBackupsMockData: OrganizationBackupItem[] = [
  {
    createOn: new Date(),
    organizationId: '',
    backupId: '',
    organizationName: 'SPTAB',
  },
];
